﻿// Import of creatApp from Vue 3 bundler.
import { createApp } from 'vue/dist/vue.esm-bundler';

// App imports.
import courseApp from './vue/courses';
import newsletterApp from './vue/newsletter.js';
import newsApp from './vue/news.js';


document.addEventListener('DOMContentLoaded', () => {
    // Mounting containers listing and DOM targeting.
    const courseContainer = document.getElementById('courses');

    const courseWidgetContainers = document.querySelectorAll('.widget-courses');

    const newsOverviewContainer = document.getElementById('news-overview');

    const newsWidgetContainers = document.querySelectorAll('.widget-news');

    const newsletterContainers = document.querySelectorAll('.widget-newsletter');

    // For each app, only build the Vue instance if the targeted element is present and mount the app on the targeted element.
    if (courseContainer) {
        createApp(courseApp).mount(courseContainer);
    }

    courseWidgetContainers.forEach(container => {
        createApp(courseApp).mount(container);
    });

    if (newsOverviewContainer) {
        createApp(newsApp).mount(newsOverviewContainer);
    }

    newsWidgetContainers.forEach(container => {
        createApp(newsApp).mount(container);
    });

    newsletterContainers.forEach(newsletterContainer => {
        createApp(newsletterApp).mount(newsletterContainer);
    });
});